import { useCallback } from 'react';
import { TextField } from '@mui/material';
import { MobileTimePicker } from '@mui/lab';
import { format } from 'date-fns';

type Props = {
    label: string;
    value: Date | null;
    minTime?: number;
    maxTime?: number;
    onChange: (time: string) => void;
}

export const CustomTimePicker = ({ label, value, minTime = 7, maxTime = 19, onChange }: Props) => {
    const handleChange = useCallback((date: Date | null) => {
        onChange(date ? format(date, 'HH:mm') : '');
    }, [onChange]);

    return (
        <MobileTimePicker
            label={label}
            ampm={false}
            views={['hours', 'minutes']}
            showToolbar={false}
            disableCloseOnSelect={false}
            value={value}
            onChange={handleChange}
            renderInput={(params) => <TextField {...params} fullWidth />}
            minTime={new Date(0, 0, 0, minTime)}
            maxTime={new Date(0, 0, 0, maxTime)}
            minutesStep={15}
        />
    )
}
